import { TInputChange } from "@syntensor/common/hooks/use_form_input";

import styles from "./create.module.css";

export interface IRadioButtonFormProps {
  title: string;
  name: string;
  value: string;
  values: { id: string; name: string }[];
  onChange: (evt: TInputChange) => void;
}

export default function RadioButtonsForm({
  title,
  name,
  value,
  values,
  onChange,
}: IRadioButtonFormProps) {
  const handleInputChange = (evt: any) => {
    onChange([{ name: name, value: evt.target.value }]);

    // const newComponentTypes = value.includes(evt.target.value)
    //   ? value.filter((id: string) => id !== evt.target.value)
    //   : [...value, evt.target.value];

    // onChange([{ name: "componentTypes", value: newComponentTypes }]);
  };

  // const formattedValue = JSON.stringify(value, null, 2);

  return (
    <div className={styles.formSection}>
      <h3 className={styles.formTitle}>{title}</h3>
      <div>
        {values.map(({ id, name }) => {
          return (
            <p key={id}>
              <input
                id={id}
                type="radio"
                name={name}
                defaultValue={id}
                onChange={handleInputChange}
                checked={value.includes(id)}
              />
              <label htmlFor={id}>{name}</label>
            </p>
          );
        })}
      </div>
    </div>
  );
}
